import React, { useEffect, useState } from "react";
import CText from "../../common/CText";
import { View, Dimensions, ScrollView } from "react-native";
import CInput from "../../common/CInput";
import CustomButton from "../../common/CustomButton";
import CHeader from "./CommonComponants/Header";
import CDatePicker from "../../common/CDatePicker";
import CDropdown from "../../common/CDropdown";
import Loader from "../../common/Loader";
import pickerConstant from "../../constant/pickerConstant";
import ModalAlertForTwoButtons from "../../common/ModalAlertForTwoButtons";
import ModalAlert from "../../common/ModalAlert";
import CView from "../../common/CView";
import CDivider from "../../common/CDivider";
import MainContainer from "./CommonComponants/MainContainer";
import { saveTINominee, getNomineeRelations } from "../../api/tripInsurance";
import CImage from "../../common/CImage";
import CPrefixInputDropdown from "../../common/CPrefixInputDropdown";
import moment from "moment";
import { isCommVehcle, priceBreakUp } from "../../api/apiManager";
import useStyles from "./NomineeDetails_Styles";

export default function NomineeDetails(props) {
  console.log("props.info.proceedNavigation", props);
  const styles = useStyles();
  const onlyAlphabetPattern = "[A-Za-z]";
  const selectedLayout = props?.setActiveUserScreen;
  const isSmallDevice = Dimensions.get("window").width < 767;
  const [data, setData] = useState({
    prefix: "",
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    dob: "",
    nomineeRelation: "",
  });
  const [loading, setLoading] = useState(false);
  const [nomineeArray, setNomineeArray] = useState([]);
  const [enableProceed, setEnableProceed] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [relationshipArray, setRelationshipArray] = useState([]);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    navigate: "",
    actionButton1: "",
    actionButton2: "",
    onPress1: {},
    onPress2: {},
  });
  const [modal, setModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onHandleInput = (key, value) => {
    const dataObj = { ...data };
    dataObj[key] = value;
    setData(dataObj);
  };
  const handleDob = (val) => {
    const dataObj = { ...data };
    dataObj["dob"] = val;
    setData(dataObj);
  };

  const saveNominee = () => {
    const params = {
      mobileNo: global?.mobileNo,
      insuranceNomineeRequest: {
        nomineeTitle: data?.prefix,
        nomineeFirstName: data?.firstName,
        nomineeMiddleName: data?.middleName,
        nomineeLastName: data?.lastName,
        gender: data?.gender,
        dob: data?.dob ? moment(data?.dob).format("DD-MM-YYYY") : "",
        relationshipWithInsuredId: data?.nomineeRelation,
      },
    };

    saveTINominee(params).then((res) => {
      if (res?.statusCode == 1095) {
        const data = { ...props?.data, nomineeDetails: [res.data] };
        setNomineeArray(res.data)
        console.log(data)
        props.setData(data);
        setAlertModal({
          title: "Confirm payment",
          status: "success",
          message:`${props.data?.policyInfo?.planPrice} rupees will be debited from your FASTag account to enable ${props.data?.policyInfo?.title}`,
          navigateScreen: "",
          navigate: "",
          actionButton1: "Cancel",
          actionButton2: "Yes, proceed",
          onPress1: () => {
            props.setScreen("Benifits");
          },
          onPress2: () => {
            props?.setActiveUserScreen == "Payment Breakup"
              ? onClickAddVehBtn(res?.data)
              : props.setScreen(props.info.proceedNavigation);
          },
        });
        return;
      } else {
        setModalVisible(true);
        setAlertModalVisible(false);
        setModal({
          title: "Error",
          status: "error",
          message: res?.message,
          navigateScreen: "",
          actionButton: "OK",
        });
      }
    });
  };
  const nomineeRelationship = () => {
    getNomineeRelations()
      .then((res) => {
        const relationArray = [];
        res.data.map((index, item) => {
          relationArray.push({ label: index.relationship, value: index.id });
        });
        setRelationshipArray(relationArray);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    nomineeRelationship();
  }, []);

  const onProceed = () => {
    console.log("propsInfo", data);
    setAlertModalVisible(true);
    setAlertModal({
      title: "Undertaking",
      status: "No Status",
      message:
        "All the information submitted by me is correct to the best of my knowledge and any information found to be incorrect can result in termination of policy or claim",
      navigateScreen: "",
      navigate: "",
      actionButton1: "Edit",
      actionButton2: "Confirm",
      onPress1: () => {
        props.setScreen("personalDetails");
      },
      onPress2: () => {
          saveNominee();
      },
    });
  };

  const onSkipPress = () => {
    const data = { ...props?.data, nomineeDetails: [{}] };
    props.setData(data);
    props?.setActiveUserScreen == "Payment Breakup"
      ? onClickAddVehBtn(false)
      : props.setScreen(props.info.proceedNavigation);
  };

  const onClickAddVehBtn = (nomineeID = false) => {
    setLoading(true);
    let params = {
      status: props?.data?.addVehicleData?.status,
      userId: props?.data?.addVehicleData?.userId,
    };
    isCommVehcle(params)
      .then((res) => {
        if (
          (res.statusCode != 500 && res.statusCode > 0) ||
          res.statusCode != -1033
        ) {
          let reqObj = {
            vrn: props?.data?.addVehicleData?.vrn,
            vehicleClass: props?.data?.addVehicleData?.vehicleClass,
            mobileNo: props?.data?.addVehicleData?.mobileNo,
            tripInsurancePolicyCode: `${props?.data?.policyInfo?.planId}`,
            isRecurringPolicy:props?.data?.policyInfo?.recurring
          };
          priceBreakUp(reqObj)
            .then((res) => {
              setLoading(false);
              if (res.message == "Success!" || res.statusCode == 200) {
                let obj = {
                  ...props.data,
                  ...{ priceBreakUpData: res.data },
                };
                if(nomineeID){
                  obj = {
                    ...obj,
                    nomineeDetails:[nomineeID],
                  };
                }
                console.log(obj)
                props.setData(obj);
                setAlertModalVisible(false);
                props.setScreen("PriceBreakup");
              }
              if (
                res.statusCode < 0 ||
                res.statusCode == 500 ||
                res.statusCode == -1033
              ) {
                setModal({
                  title: "Error",
                  status: "error",
                  message: res.message,
                  navigateScreen: "",
                  actionButton: "OK",
                });
                setModalVisible(true);
                setAlertModalVisible(false);
              }
            })
            .catch((err) => {
              setModal({
                title: "Error",
                status: "error",
                message: err.message,
                navigateScreen: "",
                actionButton: "OK",
              });
              setModalVisible(true);
              setAlertModalVisible(false);
              setLoading(false);
            });
        } else {
          setVcClassModal(false);
          setModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setModalVisible(true);
          setAlertModalVisible(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        setVcClassModal(false);
        setLoading(false);
        setModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setModalVisible(true);
        setAlertModalVisible(false);
      });
  };

  useEffect(() => {
    if (
      data.nomineeRelation != "" &&
      data.prefix != "" &&
      data.firstName != "" &&
      data.lastName != "" &&
      data.gender != "" &&
      data.dob != ""
    ) {
      setEnableProceed(true);
    } else {
      setEnableProceed(false);
    }
  }, [data]);

  return (
    <MainContainer>
      <ScrollView>
        <CHeader
          onSkipPress={() => {
            onSkipPress();
          }}
          isShowSkipButton={true}
          title="Nominee Details"
          descText={"This section can also be filled at a later stage"}
          showIcon
          onPress={() => {
            props.setScreen("personalDetails");
          }}
          navigation=""
        />
        <View style={styles.mobileDescViewStyle}>
          <CText.kycDesc>
            <View style={{ marginRight: 7 }}>
              <CImage._infoIcon />
            </View>{" "}
            {"This section can also be filled at a later stage"}
          </CText.kycDesc>
        </View>

        <View style={styles.contentWrapper}>
          <View style={[styles.custInfoWrapper, { zIndex: 3 }]}>
            <View style={[styles.infoWrapper, { zIndex: 7 }]}>
              <View style={{ zIndex: 12 }}>
                <CDropdown
                  label="Relationship with nominee"
                  value={data.nomineeRelation}
                  onSelect={(value) => onHandleInput("nomineeRelation", value)}
                  items={relationshipArray}
                  style={{ width: 230 }}
                />
              </View>
              <View style={{ zIndex: 9 }}>
                <CPrefixInputDropdown
                  label="Nominee’s first name"
                  value={data.firstName}
                  onSelect={(value) => onHandleInput("prefix", value)}
                  pickerValue={data?.prefix}
                  items={pickerConstant.titleList}
                  onChangeText={(value) => onHandleInput("firstName", value)}
                />
              </View>
              <View style={{ zIndex: 4 }}>
                <CInput
                  inputType="alpha"
                  maxLength={20}
                  label="Nominee’s middle name (Optional)"
                  style={{ width: 230 }}
                  pattern={onlyAlphabetPattern}
                  value={data.middleName}
                  onChangeText={(value) => onHandleInput("middleName", value)}
                />
              </View>
              <View style={{ zIndex: 3 }}>
                <CInput
                  inputType="alpha"
                  maxLength={20}
                  label="Nominee’s last name"
                  style={{ width: 230 }}
                  pattern={onlyAlphabetPattern}
                  value={data.lastName}
                  onChangeText={(value) => onHandleInput("lastName", value)}
                />
              </View>
              <View style={{ zIndex: 2 }}>
                <CDropdown
                  label="Gender"
                  value={data.gender}
                  onSelect={(value) => onHandleInput("gender", value)}
                  items={pickerConstant.gender}
                  style={{ width: 230 }}
                />
              </View>
              <View style={{ zIndex: 1 }}>
                <CDatePicker
                  isMobile={isSmallDevice}
                  value={data.dob}
                  label="Date of birth"
                  onDateChange={(val) => handleDob(val)}
                />
              </View>
            </View>
          </View>
          <CView MT={20}>
            <CDivider />
          </CView>
          <View style={[styles.footer, { zIndex: 2 }]}>
            <View style={styles.procedBtn}>
              <CustomButton
                text="Proceed"
                onPress={enableProceed ? () => onProceed() : null}
                disable={enableProceed == false ? true : false}
              />
            </View>
          </View>
          {loading && <Loader />}
        </View>
        {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlertForTwoButtons
            title={alertModal.title}
            message={alertModal.message}
            status={alertModal.status}
            navigateScreen={alertModal.navigateScreen}
            actionButton1={alertModal.actionButton1}
            actionButton2={alertModal.actionButton2}
            color={"green"}
            onPressActionButton1={() => {
              alertModal.onPress1();
            }}
            onPressActionButton2={() => {
              alertModal.onPress2();
            }}
          />
        </View>
      )}
      </ScrollView>
     
      {modalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={modal.title}
            status={modal.status}
            message={modal.message}
            navigateScreen={modal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={() => setModalVisible(false)}
          />
        </View>
      )}
    </MainContainer>
  );
}
